import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { EmailValidator } from '../../../../shared/validators/email.validator';
import { FormStepAbstract } from '../../../../shared/components/abstract/form-step.abstract';
import { RegisterForm } from '../register-form.interface';

@Component({
  selector: 'app-card-register-form',
  standalone: true,
  templateUrl: './card-register-form.component.html',
  styleUrls: ['./card-register-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CardRegisterFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CardRegisterFormComponent),
      multi: true,
    }
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ]
})
export class CardRegisterFormComponent extends FormStepAbstract {
  @Output() submit: EventEmitter<unknown> =  new EventEmitter<unknown>();

  override form: FormGroup<RegisterForm | null> = new FormGroup<RegisterForm | null>({
    email: new FormControl<string>('', {nonNullable: true, validators: [Validators.required, EmailValidator()]}),
    phone: new FormControl<string>('', {nonNullable: true, validators: [Validators.required]}),
  });

  onSubmit(event: KeyboardEvent): void {
    if (!event.shiftKey && (event.key === 'Enter')) {
      this.submit.emit();
    }
  }
}
